import { useNavigate, useParams } from "react-router-dom";
import HeroSection from "../../components/UserComponents/heroSection.jsx";
import ExperienceCard from "../../components/vendors/ExperienceCard";
import { usePublicExperiencesByCategory } from "../../custom-hooks/queries";
import { useMemo, useState } from "react";
import { debounce } from "../../utils/HelperMethod.js";
/* ---------------- Skeleton Card ---------------- */
const ExperienceCardSkeleton = () => (
  <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 animate-pulse">
    <div className="h-48 bg-gray-200"></div>
    <div className="p-4">
      <div className="h-3 w-20 bg-gray-200 rounded mb-2"></div>
      <div className="h-4 w-full bg-gray-200 rounded mb-2"></div>
      <div className="h-4 w-3/4 bg-gray-200 rounded mb-3"></div>
      <div className="flex justify-between items-center">
        <div className="h-5 w-16 bg-gray-200 rounded"></div>
        <div className="h-3 w-12 bg-gray-200 rounded"></div>
      </div>
    </div>
  </div>
);

const ExploreCategoryPage = () => {
  const [search, setSearch] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  const handleSearchChange = (value) => {
    setSearch(value); // input ke liye instant
    debouncedSearch(value); // API ke liye delayed
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setDebouncedValue(value); // API trigger value
      }, 500),
    [],
  );
  const navigate = useNavigate();
  const { categoryId } = useParams();

  /* 🔹 TEMP: Category ID (later URL se bhi le sakte ho) */
  //   const categoryId = "b4bb3e14-1b78-42ef-9300-8481704be883";

  const { data: categoryExperiencesData, isLoading } =
    usePublicExperiencesByCategory({
      page: 1,
      pageSize: 10,
      categoryId,
      search: debouncedValue,
    });

  /* 🔹 API response mapping */
  const experiences = categoryExperiencesData?.data?.data || [];

  const handleExperienceClick = (experienceId) => {
    navigate(`/user/experience/${experienceId}`);
  };

  return (
    <>
      {/* 🔥 HERO SECTION ON TOP */}
      <HeroSection
        searchValue={search}
        onSearchChange={handleSearchChange}
        title="Explore Experiences Carefully Curated Within Your Selected Category"
        description="Find experiences that match your interests, style, and preferences — all in one place."
      />

      {/* 🔥 ONLY CARDS SECTION */}
      <div className="container mx-auto px-4 py-12">
        {isLoading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {[...Array(8)].map((_, i) => (
              <ExperienceCardSkeleton key={i} />
            ))}
          </div>
        ) : experiences.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {experiences.map((item) => (
              <div
                key={item.experienceId}
                onClick={() => handleExperienceClick(item.experienceId)}
                className="cursor-pointer"
              >
                <ExperienceCard
                  id={item.experienceId}
                  img={item.imageUrl}
                  title={item.title}
                  location={item.location}
                  price={item.priceFrom}
                  time={item.duration}
                  rating={item.ratingAvg}
                  tag="Experience"
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-center">No experiences available</p>
        )}
      </div>
    </>
  );
};

export default ExploreCategoryPage;
